<template>
<div class='vx-col w-full mt-4'>
    <div class="vx-col m-4">
        <i>La contraseña debe contener almenos 8 dígitos</i>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Contraseña</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input @change="verificar" type="password" @input="verificar" class="w-full" v-model="password" />
            <span class="text-danger text-sm">{{ error }}</span>
        </div>
    </div>
    <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
            <span>Comprobar contraseña</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-input @change="verificar" type="password" @input="verificar" class="w-full" v-model="passwordc" />
            <span class="text-danger text-sm">{{ error }}</span>
        </div>
    </div>
    <div class="vx-row text-center">
        <div class="vx-col w-full ">
            <vs-button @click="f_guardar" :disabled="btn" class="mr-3 mb-2" color="success">Cambiar contraseña</vs-button>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from '../../mixins/GeneralMixin';

export default {
    mixins: [GeneralMixin],
    components: {},
    data() {
        return {
            error: '',
            password: '',
            passwordc: '',
            btn: true,
            usuario: '',
            usu_storage: '',
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'));
        me.usu_storage = ('usuario del perfil', me.usuario[0])
        // console.log('datos usuario dl storage', me.usu_storage)

    },
    methods: {
        verificar() {
            var n = this.password.localeCompare(this.passwordc);
            if (n == 0) {
                this.error = ""
            } else {
                this.error = "Contraseñas no coinciden"
            }
            if (this.password.length >= 8 && this.passwordc.length >= 8 && this.error === '') {
                this.btn = false;
            }
        },
        f_guardar() {
            let me = this;
            let mi_data = new FormData();
            mi_data.append('idusuario', me.usu_storage.idusuario);
            mi_data.append('password', me.password);
            mi_data.append('tipo', 1);
            me.$vs.loading();
            me.$http.post(this.$server_url + 'changePassword', mi_data)
                .then((res) => {
                    // console.log(res.data);
                    me.f_notificaciones('Contraseña actualizada', "success");
                    me.$vs.loading.close();
                })
                .catch(function (e) {
                    console.log(e);
                    me.$vs.loading.close();
                })
        }
    }
};
</script>
